import { FavouriteDefinition, StoreField } from 'app/types-shared';
import { LoadFavouriteDefinitionParams } from 'app/area/favourite/types';
import { DomainNode } from 'ui/sort-order/types';

export const ACTION = {
  CLEAR_RESULTS: 'SEARCH:CLEAR_RESULTS',
  REQUEST_REPORT_CATEGORY: 'SEARCH:REQUEST_REPORT_CATEGORY',
  RECEIVE_REPORT_CATEGORY: 'SEARCH:RECEIVE_REPORT_CATEGORY',
  REQUEST_SORT_OPTIONS: 'SEARCH:REQUEST_SORT_OPTIONS',
  RECEIVE_SORT_OPTIONS: 'SEARCH:RECEIVE_SORT_OPTIONS',
  RECEIVE_ADVANCED_SEARCH_OPTIONS: 'SEARCH:RECEIVE_ADVANCED_SEARCH_OPTIONS',
  REQUEST_FAVOURITE_DEFINITION: 'SEARCH:REQUEST_FAVOURITE_DEFINITION',
  RECEIVE_FAVOURITE_DEFINITION: 'SEARCH:RECEIVE_FAVOURITE_DEFINITION',
  UPDATE_WORKING_DEFINITION: 'SEARCH:UPDATE_WORKING_DEFINITION',
  LOAD_FAVOURITE_DEFINITION_FAILURE: 'SEARCH:LOAD_FAVOURITE_DEFINITION_FAILURE',
  REQUEST_DOWNLOAD_REPORT: 'SEARCH:REQUEST_DOWNLOAD_REPORT',
  RECEIVE_DOWNLOAD_REPORT: 'SEARCH:RECEIVE_DOWNLOAD_REPORT',
  FAIL_DOWNLOAD_REPORT: 'SEARCH:FAIL_DOWNLOAD_REPORT',
  REQUEST_URL_MULTIPLE_SUPPLIERS: 'SEARCH:REQUEST_URL_MULTIPLE_SUPPLIERS',
  RECEIVE_URL_MULTIPLE_SUPPLIERS: 'SEARCH:RECEIVE_URL_MULTIPLE_SUPPLIERS',
  FAIL_RECEIVE_URL_MULTIPLE_SUPPLIERS: 'SEARCH:FAIL_LOAD_MULTIPLE_SUPPLIERS',
  REQUEST_SEARCH_REQUIRED_USERS: 'SEARCH:REQUEST_SEARCH_REQUIRED_USERS',
  RECEIVE_SEARCH_REQUIRED_USERS: 'SEARCH:RECEIVE_SEARCH_REQUIRED_USERS',
  ADD_INSTANCE: 'SEARCH:ADD_INSTANCE',
  CLEAR_INSTANCE: 'SEARCH:CLEAR_INSTANCE',
  CREATE_FAVOURITE_DEFINITION_FAILURE: 'SEARCH: CREATE_FAVOURITE_DEFINITION_FAILURE',
  VALIDATE_FAVOURITE_FILTERS: 'SEARCH:VALIDATE_FAVOURITE_FILTERS',
  REQUEST_UPDATE_REPLACE_DOMAIN_NODES: 'SEARCH:REQUEST_UPDATE_REPLACE_DOMAIN_NODES',
  RECEIVE_UPDATE_REPLACE_DOMAIN_NODES: 'SEARCH:RECEIVE_UPDATE_REPLACE_DOMAIN_NODES',
  FAIL_UPDATE_REPLACE_DOMAIN_NODES: 'SEARCH:FAIL_UPDATE_REPLACE_DOMAIN_NODES',
  REQUEST_EXTENDED_REPLACE_DOMAIN_NODES: 'SEARCH:REQUEST_EXTENDED_REPLACE_DOMAIN_NODES',
  RECEIVE_EXTENDED_REPLACE_DOMAIN_NODES: 'SEARCH:RECEIVE_EXTENDED_REPLACE_DOMAIN_NODES',
  FAIL_EXTENDED_REPLACE_DOMAIN_NODES: 'SEARCH:FAIL_EXTENDED_REPLACE_DOMAIN_NODES'
};

export class ClearResults {
  public type: string = ACTION.CLEAR_RESULTS;

  constructor(public instanceKey: string) {}
}

export class RequestReportCategory {
  public type: string = ACTION.REQUEST_REPORT_CATEGORY;

  constructor(public instanceKey: string) {}
}

export class ReceiveReportCategory {
  public type: string = ACTION.RECEIVE_REPORT_CATEGORY;
  
  constructor(public instanceKey: string, public data: StoreField[]) {}
}

export class RequestSortOptions {
  public type: string = ACTION.REQUEST_SORT_OPTIONS;

  constructor(public instanceKey: string) {}
}

export class ReceiveSortOptions {
  public type: string = ACTION.RECEIVE_SORT_OPTIONS;

  constructor(public instanceKey: string, public options: DomainNode[]) {}
}

export class RequestFavouriteDefinition {
  public type: string = ACTION.REQUEST_FAVOURITE_DEFINITION;

  constructor(public instanceKey: string) {}
}

export class ReceiveFavouriteDefinition {
  public type: string = ACTION.RECEIVE_FAVOURITE_DEFINITION;

  constructor(
    public instanceKey: string, 
    public definition: FavouriteDefinition, 
    public favouriteId: string | number
  ) {}
}

export class UpdateWorkingDefinition {
  public type: string = ACTION.UPDATE_WORKING_DEFINITION;

  constructor(public instanceKey: string, public definition: FavouriteDefinition) {}
}

export class LoadFavouriteDefinitionFailure {
  public type: string = ACTION.LOAD_FAVOURITE_DEFINITION_FAILURE;
  
  public constructor(
    public instanceKey: string, 
    public params: LoadFavouriteDefinitionParams, 
    public error: any
  ) {}
}

export class RequestDownloadReport {
  public type: string = ACTION.REQUEST_DOWNLOAD_REPORT;

  constructor(public instanceKey: string) {}
}

export class ReceiveDownloadReport {
  public type: string = ACTION.RECEIVE_DOWNLOAD_REPORT;

  constructor(public instanceKey: string) {}
}

export class FailDownloadReport {
  public type: string = ACTION.FAIL_DOWNLOAD_REPORT;

  constructor(public instanceKey: string) {}
}

export class RequestUrlMultipleSuppliers {
  public type: string = ACTION.REQUEST_URL_MULTIPLE_SUPPLIERS;

  constructor(public instanceKey: string) {}
}

export class ReceiveUrlMultipleSuppliers {
  public type: string = ACTION.RECEIVE_URL_MULTIPLE_SUPPLIERS;

  constructor(public instanceKey: string, public urlMultipleSuppliers: string) {}
}

export class FailReceiveUrlMultipleSuppliers {
  public type: string = ACTION.FAIL_RECEIVE_URL_MULTIPLE_SUPPLIERS;
  
  public constructor(public instanceKey: string, public error: any) {}
}

export class RequestSearchRequiredUsers {
  public type: string = ACTION.REQUEST_SEARCH_REQUIRED_USERS;

  constructor(public instanceKey: string) {}
}

export class ReceiveSearchRequiredUsers {
  public type: string = ACTION.RECEIVE_SEARCH_REQUIRED_USERS;

  constructor(public instanceKey: string, public searchRequiredUsers: boolean) {}
}

export class AddInstance {
  public type: string = ACTION.ADD_INSTANCE;

  constructor(public instanceKey: string) {}
}

export class ClearInstance {
  public type: string = ACTION.CLEAR_INSTANCE;

  constructor(public instanceKey: string) {}
}

export class CreateFavouriteDefinitionFailure {
  public type: string = ACTION.CREATE_FAVOURITE_DEFINITION_FAILURE;
  
  public constructor(
    public instanceKey: string, 
    public reportId: number, 
    public error: any
  ) {}
}
export class ValidateFavouriteFilters {
  public type: string = ACTION.VALIDATE_FAVOURITE_FILTERS;

  constructor(public instanceKey: string) {}
}

export class RequestUpdateReplaceDomainNodes {
  public type: string = ACTION.REQUEST_UPDATE_REPLACE_DOMAIN_NODES;

  constructor(public instanceKey: string) {}
}

export class ReceiveUpdateReplaceDomainNodes {
  public type: string = ACTION.RECEIVE_UPDATE_REPLACE_DOMAIN_NODES;
  constructor(public instanceKey: string, public newDefinition: FavouriteDefinition) {}
}

export class FailUpdateReplaceDomainNodes {
  public type: string = ACTION.FAIL_UPDATE_REPLACE_DOMAIN_NODES;
  
  public constructor(public instanceKey: string) {}
}

export class RequestExtendedReplaceDomainNodes {
  public type: string = ACTION.REQUEST_EXTENDED_REPLACE_DOMAIN_NODES;

  constructor(public instanceKey: string) {}
}

export class ReceiveExtendedReplaceDomainNodes {
  public type: string = ACTION.RECEIVE_EXTENDED_REPLACE_DOMAIN_NODES;

  constructor(public instanceKey: string) {}
}

export class FailExtendedReplaceDomainNodes {
  public type: string = ACTION.FAIL_EXTENDED_REPLACE_DOMAIN_NODES;
  
  public constructor(public instanceKey: string, public error: any) {}
}
